import React from 'react';

import {
  Paper
} from '@mui/material';

import { activityTemplates, useTabSearchParams } from 'modules';
import * as JiraTicketsTab from './JiraTicketsTab/JiraTicketsTab';
import * as LoadTab from './LoadTab/LoadTab';
import * as NetSuiteRecordsTab from './NetSuiteRecordsTab/NetSuiteRecordsTab';
import * as ScheduledJobsTab from './ScheduledJobsTab/ScheduledJobsTab';
import { TabBar } from 'iron-forge-react-modules';



export const DebugActivity: React.FC = () => {
  const [tabId, setTabId] = useTabSearchParams({
    paramName: 'tabId',
    defaultTabId: 'load'
  });

  return (
    <activityTemplates.AdminActivityTemplate.FC>
      <TabBar.FC
        tabId={tabId ?? 'load'}
        tabs={[
          {
            id: 'load',
            label: "Load"
          },
          {
            id: 'jiraTickets',
            label: "JIRA Tickets"
          },
          {
            id: 'daemons',
            label: "Daemons"
          },
          {
            id: 'netSuiteRecords',
            label: "NetSuite Records"
          }
        ]}
        onSelectTab={tabId => setTabId(tabId)} />

      <Paper>
        {tabId === 'load' && <LoadTab.FC />}
        {tabId === 'jiraTickets' && <JiraTicketsTab.FC />}
        {tabId === 'daemons' && <ScheduledJobsTab.FC />}
        {tabId === 'netSuiteRecords' && <NetSuiteRecordsTab.FC />}
      </Paper>
    </activityTemplates.AdminActivityTemplate.FC>
  );
};
